import { useEffect, useState } from "react"
import { Row, Col, Modal } from "react-bootstrap"
import { FaMoneyBill } from "react-icons/fa"

const CourrierEmpresaConfig  = ({ component, item, titulo, onChange }) => {
        const [ showModal, setShowModal ] = useState(false)
        const [ provider, setProvider ] = useState(item || {})

        useEffect(() => {
            setProvider(item)
        },[item])
        
        const handleChange = (e) => {
            const { name, value } = e.target
            return setProvider(prev => {
                let actual = {...prev}
                actual[name] = value
                if(name === "profit_type") actual.profit = 0
                if(onChange) onChange(actual)
                return {...{}, ...actual}
            })
        }

    return <div>
        <div className="hover" onClick={() => setShowModal(true)}>{component}</div>
        <Modal show={showModal} size="lg" onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title>{titulo}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="p-2">
                <h5 className="mt-3"><b><FaMoneyBill /> Profit</b></h5>
                <Row>
                    <Col xs={3}>
                    <label className="form-control-label bold">Tipo</label>
                    <select className="form-control" name="profit_type" value={provider.profit_type} onChange={handleChange}>
                        <option value="">Ninguno</option>
                        <option value="percentage">Porcentaje</option>
                        <option value="fixed">Fijo</option>
                    </select>
                    </Col>
                    <Col>
                    <label className="form-control-label bold">Valor</label>
                    <input className="form-control" type="number" placeholder="Profit" value={provider.profit} name="profit" onChange={handleChange} />
                    </Col>
                </Row>
                </div>
            </Modal.Body>
        </Modal>
    </div>
}

export default CourrierEmpresaConfig